const DATA_ID_ATTRIBUTE = 'data-table-widget-id';

export { DATA_ID_ATTRIBUTE };
